import type { CustomAnalyticsChart } from "@redotech/redo-analytics-common/reports/custom-analytics-chart";
import { RedoLineAndBarChart } from "@redotech/redo-web/arbiter-components/charts/line-and-bar-chart/redo-line-and-bar-chart";
import { memo, useMemo } from "react";
import {
  buildLineChartDateFormatter,
  buildLineChartSeries,
  MAX_LINE_POINT_MARKERS,
} from "./custom-analytics-chart-card-utils";

export const LineChartBody = memo(function LineChartBody({
  chart,
  formatValue,
}: {
  chart: CustomAnalyticsChart;
  formatValue: (value: number) => string;
}) {
  const lineSeries = useMemo(
    () => buildLineChartSeries(chart.series),
    [chart.series],
  );

  const dateFormatter = useMemo(
    () => buildLineChartDateFormatter(chart.labels),
    [chart.labels],
  );

  return (
    <RedoLineAndBarChart
      chartStyle="line"
      dateFormatter={dateFormatter}
      legendPosition={chart.series.length > 1 ? "bottom" : undefined}
      series={lineSeries}
      showPoints={chart.labels.length <= MAX_LINE_POINT_MARKERS}
      showTooltipSeriesNames={chart.series.length > 1}
      valueAxisFormatter={formatValue}
      valueTooltipFormatter={formatValue}
    />
  );
});
